/**
 * Returns the policy name from the policy id
 * @param {string} id The id of the right size policy
 * @returns {string} The name of the policy or blank of not available
 */
export function awsRightSizePolicyIdToString(id: string): string {
    const policyMap = new Map([
        ['502', 'Average utilization'],
        ['503', 'Peak utilization'],
        ['504', 'On-Premises capacity'],
    ]);

    return policyMap.get(id) ?? '';
}
